interface QuickReplyChipsProps {
  options: string[]
  onSelect: (option: string) => void
}

export function QuickReplyChips({ options, onSelect }: QuickReplyChipsProps) {
  if (options.length === 0) return null

  return (
    <fieldset
      className="flex gap-2 overflow-x-auto pb-1 scrollbar-none border-none p-0 m-0"
      aria-label="Quick reply options"
    >
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onSelect(option)}
          className="shrink-0 px-3 py-1.5 text-sm rounded-full border border-brand text-brand hover:bg-brand hover:text-brand-foreground transition-colors"
        >
          {option}
        </button>
      ))}
    </fieldset>
  )
}
